import { Component, effect, input, signal, WritableSignal } from '@angular/core';

@Component({
  selector: 'tech-level',
  template: '<span>{{ techLevelString() }}</span>',
  standalone: false
})
export class TechLevelComponent {
  techLevel = input<number>();
  techLevelString: WritableSignal<string> = signal('');

  constructor () {
    effect(() => {
      let tl = this.techLevel();
      if (tl == null) {
        return;
      }
      let techLevelString: string = (tl == -2) ? "Pre-Ind" : (tl == -1) ? "Ind-1" : (tl == 0) ? "Ind-2" : '' + tl;
      this.techLevelString.set(techLevelString);
    });
  };
};
